(function () {
  'use strict';

  if (window.__inesNewsletterLoaded) return;
  window.__inesNewsletterLoaded = true;

  var initializedForms = new WeakSet();
  var personas = ['parent', 'eleve'];
  var levels = ['6eme', '5eme', '4eme', '3eme', 'seconde', 'premiere', 'terminale'];

  function showStatus(form, message) {
    var status = form.querySelector('[data-newsletter-status]');
    if (!status) return;
    status.textContent = message;
    status.hidden = !message;
  }

  function identifySubscriber(email) {
    if (!window.Brevo || typeof window.Brevo.push !== 'function') return;
    // Analytics is optional: a tracker failure must not undo an accepted signup.
    try {
      window.Brevo.push(function () {
        try {
          window.Brevo.identify({ identifiers: { email_id: email } });
        } catch (error) {
          // Signup has already been confirmed by both destinations.
        }
      });
    } catch (error) {
      // A blocked analytics script does not block the confirmation page.
    }
  }

  function confirmationUrl(form) {
    var currentUrl = new URL(window.location.href);
    var redirect = new URL(form.dataset.redirectUrl || '/pages/merci-newsletter', currentUrl);
    var previewId = currentUrl.searchParams.get('preview_theme_id');
    if (previewId) redirect.searchParams.set('preview_theme_id', previewId);
    return redirect.href;
  }

  function initializeForm(form) {
    if (initializedForms.has(form)) return;
    initializedForms.add(form);

    var pending = false;
    var complete = false;
    var acceptedMakeSignup = '';

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (pending || complete) return;

      var emailField = form.elements.namedItem('contact[email]');
      var personaField = form.elements.namedItem('persona');
      var levelField = form.elements.namedItem('level');
      var consentField = form.elements.namedItem('newsletter_consent');
      var honeypot = form.elements.namedItem('hp_field');
      if (honeypot && honeypot.value) return;

      var email = emailField ? emailField.value.trim() : '';
      var persona = personaField ? personaField.value : '';
      var level = levelField ? levelField.value : '';
      if (emailField) emailField.value = email;

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      var consentGiven = consentField && consentField.checked;
      if (form.dataset.consentMode === 'submit') {
        // This declared newsletter form accepts consent only through a valid
        // submission with its visible notice. Other forms still need a checkbox.
        var consentNotice = form.querySelector('[data-newsletter-consent-notice]');
        var noticeStyle = consentNotice && window.getComputedStyle(consentNotice);
        consentGiven = !!consentNotice && !consentNotice.hidden
          && consentNotice.getAttribute('aria-hidden') !== 'true'
          && consentNotice.getClientRects().length > 0
          && noticeStyle.display !== 'none' && noticeStyle.visibility !== 'hidden';
      }
      if (!email || personas.indexOf(persona) === -1 || levels.indexOf(level) === -1 || !consentGiven) {
        showStatus(form, 'Choisissez votre profil, votre classe et acceptez de recevoir la newsletter.');
        return;
      }

      var webhookUrl = form.dataset.webhookUrl;
      var listId = Number(form.dataset.listId);
      if (!webhookUrl || !Number.isInteger(listId) || listId <= 0) {
        showStatus(form, 'L’inscription est temporairement indisponible. Réessayez plus tard.');
        return;
      }

      var tags = form.elements.namedItem('contact[tags]');
      if (tags) tags.value = 'newsletter,newsletter_' + persona + ',newsletter_' + level;
      // Capture the form before awaiting Make so an edited field cannot silently
      // put a different segment or email into the Shopify save.
      var shopifyBody = new FormData(form);
      var signupKey = JSON.stringify([email, persona, level]);
      var button = form.querySelector('[type="submit"]');
      var originalButtonHtml = button ? button.innerHTML : '';
      var stage = 'make';
      pending = true;
      showStatus(form, 'Inscription en cours…');
      form.setAttribute('aria-busy', 'true');
      if (button) {
        button.disabled = true;
        button.textContent = 'Inscription en cours…';
      }

      try {
        if (acceptedMakeSignup !== signupKey) {
          var makeResponse = await fetch(webhookUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email: email,
              listId: listId,
              source: 'footer_form',
              persona: persona,
              level: level,
              consent: true
            })
          });
          if (!makeResponse.ok) throw new Error('L’inscription n’a pas pu être enregistrée. Réessayez dans un instant.');
          var makeResult;
          try {
            makeResult = await makeResponse.json();
          } catch (error) {
            throw new Error('L’inscription n’a pas été confirmée. Réessayez dans un instant.');
          }
          if (!makeResult || makeResult.ok !== true) {
            throw new Error('L’inscription n’a pas été confirmée. Réessayez dans un instant.');
          }
          acceptedMakeSignup = signupKey;
        }

        var inlineSuccess = form.dataset.successMode === 'inline';
        stage = 'shopify';
        try {
          var shopifyResponse = await fetch(form.action, {
            method: 'POST',
            credentials: 'same-origin',
            body: shopifyBody
          });
          if (!shopifyResponse.ok) throw new Error('L’enregistrement sur la boutique a échoué. Réessayez dans un instant.');

          var result = new DOMParser().parseFromString(await shopifyResponse.text(), 'text/html');
          var shopifyError = result.querySelector('[data-newsletter-error]');
          if (shopifyError) throw new Error(shopifyError.textContent.trim() || 'L’enregistrement sur la boutique a échoué.');
          if (!result.querySelector('[data-newsletter-success]')) {
            throw new Error('La boutique n’a pas confirmé l’enregistrement. Réessayez dans un instant.');
          }
        } catch (error) {
          // Brevo is the subscription source of truth. Its explicit acceptance
          // already confirms inline signup; Shopify is an optional mirror here,
          // so mirror errors must never invite another Brevo opt-in.
          if (!inlineSuccess) throw error;
        }

        if (inlineSuccess) {
          showStatus(form, 'Merci ! Votre inscription a bien été enregistrée.');
          if (button) button.textContent = 'Inscription enregistrée';
        } else {
          var redirectUrl = confirmationUrl(form);
          identifySubscriber(email);
          window.location.assign(redirectUrl);
        }
        complete = true;
        try {
          // Remember accepted signup even when no popup controller is loaded.
          // Store only a boolean; browser storage may be unavailable.
          window.localStorage.setItem('ines_newsletter_subscribed', '1');
        } catch (error) {
          // Optional browser persistence must not undo an accepted signup.
        }
        form.dispatchEvent(new CustomEvent('ines:newsletter:success', { bubbles: true }));
      } catch (error) {
        var fallback = stage === 'shopify'
          ? 'L’enregistrement sur la boutique a échoué. Réessayez dans un instant.'
          : 'L’inscription n’a pas pu être enregistrée. Vérifiez votre connexion et réessayez.';
        showStatus(form, error instanceof TypeError ? fallback : (error.message || fallback));
      } finally {
        pending = false;
        form.removeAttribute('aria-busy');
        if (button && !complete) {
          button.innerHTML = originalButtonHtml;
          button.disabled = false;
        }
      }
    });

    // Liquid starts this button disabled so signup cannot bypass the webhook
    // when JavaScript is unavailable. Enable it after the handler is installed.
    var submitButton = form.querySelector('[type="submit"]');
    if (submitButton) submitButton.disabled = false;
  }

  function initialize(root) {
    if (root.matches && root.matches('[data-ines-newsletter]')) initializeForm(root);
    root.querySelectorAll('[data-ines-newsletter]').forEach(initializeForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
